<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (role of roles | async; track trackBy(role)) {
      <lcs-option [value]="role" id="lcs-option-id-{{ role.roleId }}">
         {{ role.name }}
      </lcs-option>
      }
   </div>
</ng-template>
